import React, {useEffect, useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashborad.css";
import {FaEdit, FaWpforms} from "react-icons/fa";
import {
    FaBars,
    FaHome,
    FaUser,
    FaChartBar,
    FaCog,
    FaSignOutAlt,
} from "react-icons/fa";
import Form8 from "./Form8/Form8";
import Form8Data from "./Form8/Form8Data";
import {HeaderDashboard, SideNav} from "./Componat/Header and Side Nav/NavComponant";
import {BaseURL} from "../../API/API";
import {MdDelete} from "react-icons/md";

const Dashboard = () => {
    let getMySession=JSON.parse(sessionStorage.getItem('data'))[0];
    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);

    return (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                <main className={`p-4 w-100 main`}>
                    {
                        getMySession.UserType==="admin"?
                            <MainContain/>
                            :
                            <h1>This section access only admin.</h1>
                    }
                </main>
            </div>
        </div>
    );
};

export default Dashboard;

function MainContain() {
    const [users,setUsers]=useState([]);
    const [groupVillage,setGroupVillage]=useState([]);
    const [show,setShow]=useState(false);
    const [editItem,setEditItem]=useState(null);

    const [updateVillage,setUpdateVillage]=useState(false);
    const [villageItem,setVillageItem]=useState(null);

    useEffect(()=>{
        let user = sessionStorage.getItem("username");
       // console.log(user);
        ReadUsers();
        ReadGroupVillage();
    },[])

    function ReadUsers() {
        let form = new FormData();
        form.append('searchTerm',"");

        fetch(BaseURL + 'GM.php/SearchReg', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    const parsedData = JSON.parse(data); // First level parse
                    setUsers(JSON.parse(parsedData));
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    function Delete(item) {
        let form = new FormData();
        form.append('idReg',item.idReg);

        fetch(BaseURL + 'GM.php/DeleteReg', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                window.location.reload();
                //alert(data.index);
                // dispatch(deleteForm8DataByIndex(data.index));
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });

    }
    function Edit(item) {
        setEditItem(item);
        setShow(true);
    }

    function ReadGroupVillage() {
        let form = new FormData();
        fetch(BaseURL + 'GM.php/GetGroupCity', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    const parsedData = JSON.parse(data); // First level parse
                    console.log(JSON.parse(parsedData));
                    setGroupVillage(JSON.parse(parsedData));
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    function LogIn(userName,password) {
        let form = new FormData();
        form.append('userName',userName);
        form.append('password',password);
        fetch(BaseURL + 'GM.php/LogIn', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    const parsedData = JSON.parse(data); // First level parse
                    if(JSON.parse(parsedData).length>0){
                        sessionStorage.setItem("data", parsedData);
                      //  navigate('/admin/home');
                        window.location.reload();
                    }
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    function ShareUrl(userName, password) {
        const currentUrl = window.location.href;
        const encodedUserName = encodeURIComponent(userName);
        const encodedPassword = encodeURIComponent(password);

        const shareUrl = currentUrl.replace(
            '/admin/home',
            `/login?userName=${encodedUserName}&password=${encodedPassword}`
        );

        const message = `Click the link to login: ${shareUrl}`;

        // Check if Web Share API is supported
        if (navigator.share) {
            navigator.share({
                title: 'Login Link',
                text: message,
                url: shareUrl
            }).then(() => {
                console.log('Shared successfully');
            }).catch((error) => {
                console.error('Error sharing:', error);
            });
        } else {
            // Fallback: show options like WhatsApp, Messenger manually
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
            const messengerUrl = `fb-messenger://share/?link=${encodeURIComponent(shareUrl)}`;

            const choice = prompt("Your browser doesn't support the Share API.\nChoose where to share:\n1. WhatsApp\n2. Messenger\n3. Just Copy URL\n\nEnter 1, 2, or 3:");

            if (choice === "1") {
                window.open(whatsappUrl, '_blank');
            } else if (choice === "2") {
                window.open(messengerUrl, '_blank');
            } else {
                navigator.clipboard.writeText(shareUrl).then(() => {
                    alert("URL copied to clipboard:\n" + shareUrl);
                });
            }
        }
    }

    function Download(city,totalRecord) {
        window.open(BaseURL+'Test4.php?v='+city+'&t='+totalRecord, '_blank');
    }


    return <>
        <div className="d-flex justify-content-end p-3 card">
            <button onClick={()=>setShow(true)} className="btn btn-primary">Add User</button>
        </div>

        <div className="card p-3 mt-2">
            <table className="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>UserName</th>
                        <th>Password</th>
                        <th>Type</th>
                        <th>Village</th>
                        <th>Action</th>
                        <th>LogIn</th>
                        <th>Share</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>
                {
                    users.map((item,index)=>(
                        <tr key={`row-${index}`}>
                            <td>{index+1}</td>
                            <td>{item.UserName}</td>
                            <td>{item.Password}</td>
                            <td>{item.UserType}</td>
                            <td>{item.VilageName}</td>
                            <td>
                                <button onClick={()=>Edit(item)} className="btn m-1"><FaEdit/></button>
                                {
                                    item.UserName!="pravinhote"&&
                                    <button onClick={()=>Delete(item)} className="btn m-1"><MdDelete /></button>
                                }
                            </td>
                            <td>
                                {
                                    item.UserName!="pravinhote"&&
                                    <button onClick={()=>{LogIn(item.UserName,item.Password)}} className="btn btn-primary">Log In</button>
                                }
                            </td>
                            <td>
                                {
                                    item.UserName!="pravinhote"&&
                                    <button onClick={()=>{ShareUrl(item.UserName,item.Password)}} className="btn btn-primary">Share</button>
                                }
                            </td>
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </div>
        <div className="card p-3 mt-2">
            <h4>Village Name</h4>
            <table className="table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>VillageName</th>
                    <th>Total Record</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {
                    groupVillage.map((item,index)=>(
                        <tr>
                            <td>{index+1}</td>
                            <td>{item.GramPanchayat_Name1}</td>
                            <td>{item.total_records}</td>
                            <td><button onClick={()=>{
                                setVillageItem(item.GramPanchayat_Name1);
                                setUpdateVillage(true);
                            }} className="btn btn-primary">Edit</button></td>
                            <td><button onClick={()=>{Download(item.GramPanchayat_Name1,item.total_records);}} className="btn btn-primary">Download</button></td>
                        </tr>
                    ))
                }
                </tbody>

            </table>
        </div>
        {
            show&&
            <AddNewUser item={editItem} setItem={setEditItem} show={show} setShow={setShow}/>
        }
        {
            updateVillage&&
                <UpdateVillage villageItem={villageItem} setUpdateVillage={setUpdateVillage}  />
        }
    </>
}


const AddNewUser = React.memo(({item,setItem, show, setShow }) => {
    const [username, setUserName] = useState(item==null?"":item.UserName);
    const [password, setPassword] = useState(item==null?"":item.Password);
    const [userType, setUserType] = useState(item==null?"admin":item.UserType);
    const [village, setVillage] = useState(item==null?"":item.VilageName);

    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setItem(null);
        setShow(false);
    };

    const validate = () => {
        let err = {};
        if (username.length < 8) {
            err.username = "Username must be at least 8 characters";
        }
        if (password.length < 8) {
            err.password = "Password must be at least 8 characters";
        }
        if (!village.trim()) {
            err.village = "Village name is required";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleConfirm = () => {
        if (!validate()) return;

        let form = new FormData();
        form.append('UserName', username);
        form.append('Password', password);
        form.append('UserType', userType);
        form.append('VilageName', village.trim());

        fetch(BaseURL + 'GM.php/InsertReg', {
            method: 'POST',
            body: form
        })
            .then(res => res.text())
            .then(data => {
                window.location.reload();
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });

        setShow(false);
    };

    const Update=()=>{
        if (!validate()) return;
        let form = new FormData();
        form.append('idReg',item.idReg);
        form.append('UserName', username);
        form.append('Password', password);
        form.append('UserType', userType);
        form.append('VilageName', village.trim());

        fetch(BaseURL + 'GM.php/UpdateReg', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                window.location.reload();
                //alert(data.index);
                // dispatch(deleteForm8DataByIndex(data.index));
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    const CheckUser=()=>{
        if(username.length<8) return false;
        let form = new FormData();
        form.append('UserName', username);

        fetch(BaseURL + 'GM.php/UserNameAlreadyExist', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                let parseData=JSON.parse(data);
                if(JSON.parse(parseData).length>0){
                    let err = {};
                    err.UserExist="UserName already exist.";
                    setErrors(err);
                }else{
                    setErrors({});
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    return (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{item==null?"Create New User":"Edit User"}</h5>
                        <button onClick={handleClose} type="button" className="btn-close"></button>
                    </div>
                    <div className="modal-body">
                        {
                            item===null&&
                            <input
                                onKeyUp={CheckUser}
                                onChange={(e) => setUserName(e.target.value)}
                                className="form-control mt-2"
                                placeholder="User Name"
                                value={username}
                            />
                        }
                        {errors.UserExist&&<small className="text-danger">{errors.UserExist}</small>}
                        {errors.username && <small className="text-danger">{errors.username}</small>}

                        <input
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control mt-2"
                            placeholder="Password"
                            type="password"
                            value={password}
                        />
                        {errors.password && <small className="text-danger">{errors.password}</small>}

                        <select
                            onChange={(e) => setUserType(e.target.value)}
                            className="form-control mt-2"
                            value={userType}
                        >
                            <option value="admin">Admin</option>
                            <option value="user">User</option>
                        </select>

                        <input
                            onChange={(e) => setVillage(e.target.value)}
                            className="form-control mt-2"
                            placeholder="Village Name"
                            value={village}
                        />
                        {errors.village && <small className="text-danger">{errors.village}</small>}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            Cancel
                        </button>
                        {
                            item===null?
                                <button type="button" className="btn btn-danger" onClick={handleConfirm}>
                                    Save
                                </button>
                                :
                                <button type="button" className="btn btn-primary" onClick={Update}>
                                    Update
                                </button>
                        }


                    </div>
                </div>
            </div>
        </div>
    );
});

const UpdateVillage=React.memo(({villageItem,setUpdateVillage})=>{
    const [newCity,setNewCity]=useState('');
    function handleClose() {
        setUpdateVillage(false);
    }

    function Update() {
        if(newCity==""){return false;}
        let form = new FormData();
        form.append('UpdateCity',villageItem);
        form.append('OrignalValue',newCity);
        fetch(BaseURL + 'GM.php/UpdateCity', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {

                window.location.reload();
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    return (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Update Village</h5>
                        <button onClick={handleClose} type="button" className="btn-close"></button>
                    </div>
                    <div className="modal-body">
                       <input value={villageItem} className="form-control" readOnly={true} disabled={true}/>
                        <input onChange={(e)=>setNewCity(e.target.value)} className="form-control mt-2" placeholder={"Village Name"}/>
                        <button onClick={Update} className="btn btn-primary mt-2">Update</button>
                    </div>
                </div>
            </div>

        </div>
    )
})


